import Duck from 'custom-redux-ducks-ts'

export const user = new Duck('user', 'eduprivada')
